import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { Heading, Spacer, Text } from "@badi/badi-components";

const ListRoomApartmentSection = ({ children, description = null, title }) => (
  <Row>
    <Col>
      <Heading data-qa="landing-section-title" level="28-Extrabold">
        {title}
      </Heading>
      <Spacer bottom={6} top={2}>
        <Text dataQa="landing-section-desc">{description}</Text>
      </Spacer>
      {children}
    </Col>
  </Row>
);

ListRoomApartmentSection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default ListRoomApartmentSection;
